<template>
    <div class="container">

        <AgentLoaderComponent ref="AgentLoaderComponent"></AgentLoaderComponent>

        <b-modal id="openCalendarReservationModal" title="講師スケジュール" size="xl"
            dialog-class="custom-wide-modal agent-reservation-dialog" content-class="agent-reservation-content rounded"
            header-class="agent-reservation-modal-header border-0" body-class="agent-reservation-modal-body"
            footer-class="agent-reservation-modal-footer border-0" ok-only ok-title="閉じる" ok-variant="primary"
            modal-class="agent-netenglish-modal">

            <!--[start] Date Picker -->
            <div id="datePickerWrapper" class="agent-reservation-toolbar mb-3">

                <div class="row align-items-start">
                    <div class="col-lg-4 mb-3 mb-lg-0">
                        <label class="agent-reservation-date-label d-block small font-weight-bold text-muted mb-1">日付</label>
                        <datepicker v-model="currentDate" name="date" :format="customFormatter"
                            :calendar-button="true" calendar-button-icon="fas fa-calendar-alt"
                            :bootstrap-styling="true" class="datepicker-input agent-reservation-datepicker" @input="changeDate">
                        </datepicker>
                    </div>

                    <div class="col-lg-8">
                        <div class="agent-reservation-legend card border-0 shadow-sm">
                            <div class="card-body py-3 px-3">
                                <div class="row">
                                    <div class="col-md-6 mb-3 mb-md-0">
                                        <div class="agent-reservation-legend-heading">予約状態</div>
                                        <ul class="list-unstyled mb-0 agent-reservation-legend-status">
                                            <li>
                                                <span class="schedule-legend-chip schedule-legend-chip--bookable">予約する</span>
                                                <span class="agent-reservation-legend-text">予約可能</span>
                                            </li>
                                            <li>
                                                <span class="schedule-legend-chip schedule-legend-chip--yours">自校予約済み</span>
                                                <span class="agent-reservation-legend-text">自校で予約済み</span>
                                            </li>
                                            <li>
                                                <span class="schedule-legend-chip schedule-legend-chip--other">予約不可</span>
                                                <span class="agent-reservation-legend-text">他の受講生または講師都合により予約不可</span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="agent-reservation-legend-heading">ご利用ルール</div>
                                        <ul class="agent-reservation-rules mb-0 pl-3">
                                            <li>レッスン予約は開始30分前まで可能です。</li>
                                            <li>キャンセルは開始3時間前まで可能です。</li>
                                            <li>受講生1名につき、最大15コマまで予約できます。</li>
                                            <li>同一日・同一講師の予約は最大2コマまでです。</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--[end] Date Picker -->

            <!-- <button @click="refreshAgentCalendarViewer()">test viewer</button>-->

            <div class="agent-reservation-date-banner text-center text-white font-weight-bold">
                {{ formattedDate }}
            </div>

            <div id="tutor_content_holder" class="agent-reservation-grid-wrap scrollable-x text-center">

                <table class="table table-bordered table-schedules agent-reservation-table mb-0">
                    <thead>
                        <tr>
                            <th class="schedTime static agent-res-sched-corner">
                                <div class="bordered agent-res-sched-corner-inner">
                                    <div class="class-schedule-container">
                                        <span class="flag-jp" style="vertical-align: bottom;"></span>
                                    </div>
                                </div>
                            </th>

                            <td class="schedTime agent-res-time-head" v-for="(time, index) in timeSlots" :key="index">
                                <div class="bordered agent-res-time-cell">
                                    <div class="agent-res-time-start">{{ time }}</div>
                                    <div class="agent-res-time-end text-muted">{{ calculateEndTime(time) }}</div>
                                </div>
                            </td>
                        </tr>

                        <tr v-for="(tutor, index) in tutors" :key="'tutor-' + tutor.user_id">

                            <td :id="'tutor-' + tutor.user_id" class="tutors agent-res-tutor-cell">

                                <div v-if="tutor.filename == null" class="agent-res-tutor-photo-wrap">
                                    <img src="https://mypage.mytutor-jpn.com/storage/user_images/noimage.jpg"
                                        class="agent-res-tutor-photo" alt="">
                                </div>
                                <div v-else class="agent-res-tutor-photo-wrap">
                                    <img :src="tutor.filename" class="agent-res-tutor-photo" alt="">
                                </div>

                                <div class="tutor-name agent-res-tutor-name">
                                    {{ tutor.firstname }}
                                </div>
                            </td>

                            <td class="timeslot agent-res-slot" v-for="(time, index) in timeSlots" :key="'' + index">


                                <div v-if="index <= 25">

                                    <div
                                        v-if="lessons[tutor.user_id] && lessons[tutor.user_id][currentDate] && lessons[tutor.user_id][currentDate][japanTime(time)]">


                                        <div
                                            v-if="lessons[tutor.user_id][currentDate][japanTime(time)]['status'] == 'TUTOR_SCHEDULED'">
                                            <a href="#"
                                                class="schedule-action schedule-action--bookable"
                                                @click.prevent="openMemberSelection(tutor, lessons[tutor.user_id][currentDate][japanTime(time)])">予約する</a>
                                        </div>

                                        <div
                                            v-else-if="lessons[tutor.user_id][currentDate][japanTime(time)]['agent_id'] !== agent_user_id">
                                            <span class="schedule-pill schedule-pill--other">予約不可</span>
                                        </div>

                                        <div
                                            v-else-if="lessons[tutor.user_id][currentDate][japanTime(time)]['status'] == 'CLIENT_RESERVED'
                                                || lessons[tutor.user_id][currentDate][japanTime(time)]['status'] == 'CLIENT_RESERVED_B'">
                                            <a href="#"
                                                class="schedule-action schedule-action--yours"
                                                @click.prevent="cancelBooking(tutor, lessons[tutor.user_id][currentDate][japanTime(time)])">自校予約済み</a>

                                        </div>
                                        <div
                                            v-else-if="lessons[tutor.user_id][currentDate][japanTime(time)]['status'] == 'CLIENT_NOT_AVAILABLE'
                                                || lessons[tutor.user_id][currentDate][japanTime(time)]['status'] == 'SUPPRESSED_SCHEDULE'
                                                || lessons[tutor.user_id][currentDate][japanTime(time)]['status'] == 'TUTOR_CANCELLED'">
                                            <span class="schedule-pill schedule-pill--other">予約不可</span>
                                        </div>
                                        <div
                                            v-else-if="lessons[tutor.user_id][currentDate][japanTime(time)]['status'] == 'COMPLETED'">
                                            <div class="comment_tooltip">
                                                <a href="#"
                                                    class="schedule-pill schedule-pill--other schedule-pill--link"
                                                    @click.prevent="viewComments(lessons[tutor.user_id][currentDate][japanTime(time)][id])">
                                                    予約不可
                                                </a>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <div v-if="index >= 26">
                                    <div
                                        v-if="lessons[tutor.user_id] && lessons[tutor.user_id][nextDate] && lessons[tutor.user_id][nextDate][japanTime(time)]">


                                        <div
                                            v-if="lessons[tutor.user_id][nextDate][japanTime(time)]['status'] == 'TUTOR_SCHEDULED'">
                                            <a href="#"
                                                class="schedule-action schedule-action--bookable"
                                                @click.prevent="openMemberSelection(tutor, lessons[tutor.user_id][nextDate][japanTime(time)])">予約する</a>
                                        </div>

                                        <div
                                            v-else-if="lessons[tutor.user_id][nextDate][japanTime(time)]['agent_id'] !== agent_user_id">
                                            <span class="schedule-pill schedule-pill--other">予約不可</span>
                                        </div>

                                        <div
                                            v-else-if="lessons[tutor.user_id][nextDate][japanTime(time)]['status'] == 'CLIENT_RESERVED'
                                                || lessons[tutor.user_id][nextDate][japanTime(time)]['status'] == 'CLIENT_RESERVED_B'">

                                            <a href="#"
                                                class="schedule-action schedule-action--yours"
                                                @click.prevent="cancelBooking(tutor, lessons[tutor.user_id][nextDate][japanTime(time)])">自校予約済み</a>
                                        </div>

                                        <div
                                            v-else-if="lessons[tutor.user_id][nextDate][japanTime(time)]['status'] == 'CLIENT_NOT_AVAILABLE'
                                                || lessons[tutor.user_id][nextDate][japanTime(time)]['status'] == 'SUPPRESSED_SCHEDULE'
                                                || lessons[tutor.user_id][nextDate][japanTime(time)]['status'] == 'TUTOR_CANCELLED'">
                                            <span class="schedule-pill schedule-pill--other">予約不可</span>
                                        </div>

                                        <div
                                            v-else-if="lessons[tutor.user_id][nextDate][japanTime(time)]['status'] == 'COMPLETED'">
                                            <div class="comment_tooltip">
                                                <a href="#"
                                                    class="schedule-pill schedule-pill--other schedule-pill--link"
                                                    @click.prevent="viewComments(lessons[tutor.user_id][nextDate][japanTime(time)])">予約不可</a>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </td>
                        </tr>
                    </thead>
                </table>
            </div>
        </b-modal>

        <AgentSchedulerComponent ref="AgentSchedulerComponent" :currentDate="this.currentDate" :nextDate="this.nextDate"
            :api_token="this.api_token" :agent_user_id="agent_user_id" :agent_info="this.agent_info"
            @call-open-loading-modal="callOpenAgentLoaderModal" @call-close-loading-modal="callCloseAgentLoaderModal"
            @call-refresh-calender="refreshCalender"></AgentSchedulerComponent>



    </div>
</template>



<script>
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';

import AgentLoaderComponent from '../../backend/agent/AgentLoaderComponent.vue';
import AgentSchedulerComponent from '../../backend/agent/AgentSchedulerComponent.vue';

export default {
    components: {
        Datepicker, AgentSchedulerComponent, AgentLoaderComponent
    },
    props: {
        firstname: String,
        csrf_token: String,
        api_token: String,
        agent_info: Object,
        agent_user_id: Number,
    },
    data() {
        return {
            componentKey: 1,
            timeSlots: [], // Array to store time slots
            selectedDate: null,
            currentDate: null,
            nextDate: null,
            formattedDate: null,
            tutors: [],
            lessons: [],
        };
    },
    mounted() {

        console.log(this.currentDate);
        this.getTutorsList();
        this.generateTimeSlots();
        this.setCurrentDate()


        //get the testing
        window.refreshAgentCalendarViewer = () => this.refreshAgentCalendarViewer();


    },
    methods: {
        refreshAgentCalendarViewer() {
            window.refreshAgentCalendarViewer(this.currentDate);
        },
        japanTime(timeStr) {
            // Parse the time string into hours and minutes
            const [hours, minutes] = timeStr.split(':').map(num => parseInt(num, 10));

            // Create a Date object for today with the provided hours and minutes
            const time = new Date();
            time.setHours(hours, minutes, 0, 0); // Set the time using hours and minutes

            // Add -1 hour to the current time
            time.setHours(time.getHours() - 1);

            // Format the new time back into HH:mm format
            const newHours = time.getHours().toString().padStart(2, '0');
            const newMinutes = time.getMinutes().toString().padStart(2, '0');

            return `${newHours}:${newMinutes}`;
        },
        setCurrentDate() {
            const now = new Date();
            const year = now.getFullYear();
            const month = (now.getMonth() + 1).toString().padStart(2, "0"); // Month is zero-based
            const day = now.getDate().toString().padStart(2, "0");
            this.currentDate = `${year}-${month}-${day}`; // Format as YYYY-MM-DD
            this.formattedDate = `${year}年 ${month}月 ${day}日`; // Format as YYYY年 M月 DD日

            this.getNextDay(now);
        },
        getNextDay(currentDate) {
            const nextDate = new Date(currentDate);
            nextDate.setDate(nextDate.getDate() + 1); // Add 1 day

            const year = nextDate.getFullYear();
            const month = (nextDate.getMonth() + 1).toString().padStart(2, "0");
            const day = nextDate.getDate().toString().padStart(2, "0");

            this.nextDate = `${year}-${month}-${day}`; // Format as YYYY-MM-DD
        },
        changeDate() {
            const date = new Date(this.currentDate);
            const year = date.getFullYear(); // 2024
            const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based, so add 1 and pad with '0'
            const day = String(date.getDate()).padStart(2, "0"); // Pad day with '0'
            this.currentDate = `${year}-${month}-${day}`; // Format as YYYY-MM-DD

            this.formattedDate = `${year}年 ${month}月 ${day}日`; // Format as YYYY年 M月 DD日

            console.log(this.currentDate); // Output: 2024-11-04

            this.getNextDay(date);
            this.getSchedules();
        },
        refreshCalender() {
            console.log("refreshing calendar")
            this.getSchedules();
            this.refreshAgentCalendarViewer();
        },
        refreshContent() {
            this.$forceUpdate(); // Forces a re-render
            console.log(this.lessons);
        },
        customFormatter(date) {

            return moment(date).format('YYYY年 MM月 D日');
        },
        setCurrentMonth() {
            const now = new Date();
            const year = now.getFullYear();
            const month = (now.getMonth() + 1).toString().padStart(2, "0"); // Add leading zero if needed
            this.currentMonth = `${year}-${month}`; // Format as YYYY-MM
        },
        openCalendarReservationModal(memberUserId = null) {
            if (this.$refs.AgentSchedulerComponent) {
                this.$refs.AgentSchedulerComponent.setPendingMemberUserId(memberUserId);
                if (memberUserId) {
                    this.$refs.AgentSchedulerComponent.ensureMemberListLoaded();
                }
            }

            this.$bvModal.show('openCalendarReservationModal');

            this.getSchedules();
        },
        generateTimeSlots() {
            const start = new Date();
            start.setHours(11, 0, 0); // Start at 11:00 AM (japan)

            const end = new Date();
            end.setHours(0, 30, 0);
            end.setDate(start.getDate() + 1);// End at 12:30 AM next day

            const slots = [];
            const interval = 30; // 30 minutes
            let current = new Date(start);

            while (current <= end) {
                slots.push(this.formatMilitaryTime(current));
                current = new Date(current.getTime() + interval * 60000); // Increment by 30 minutes
            }

            this.timeSlots = slots;
        },
        formatMilitaryTime(date) {
            let hours = date.getHours();
            const minutes = date.getMinutes();
            const formattedMinutes = minutes.toString().padStart(2, "0");
            // If hours is 0 (midnight), change to 24
            if (hours === 0) { hours = 24; }
            return `${hours}:${formattedMinutes}`;
        },
        formatTime(date) {
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const ampm = hours >= 12 ? "PM" : "AM";
            const formattedHours = hours % 12 || 12;
            const formattedMinutes = minutes.toString().padStart(2, "0");
            return `${formattedHours}:${formattedMinutes} ${ampm}`;
        },
        calculateEndTime(startTime) {
            const [hours, minutes] = startTime.split(":").map(Number);
            const date = new Date();
            date.setHours(hours, minutes);
            date.setMinutes(date.getMinutes() + 25); // Add 25 minutes
            const endHours = date.getHours();
            const endMinutes = date.getMinutes().toString().padStart(2, "0");
            if (endHours === 0) {
                let hours = 24;
            } else {
                let hours = endHours;
            }
            return `${hours}:${endMinutes}`;
        },
        getTutorsList() {

            axios.post("/api/getTutorList?api_token=" + this.api_token, {
                method: "POST",

            }).then(response => {

                if (response.data.success === false) {
                    alert(response.data.message);
                } else {
                    this.tutors = response.data.tutors;
                }

            }).catch(function (error) {
                alert("Error " + error);
            });
        },
        callOpenAgentLoaderModal(message) {
            this.$refs.AgentLoaderComponent.openAgentLoaderModal(message);
        },
        callCloseAgentLoaderModal() {
            this.$refs.AgentLoaderComponent.closeAgentLoaderModal();
        },
        getSchedules() {

            this.callOpenAgentLoaderModal("講師スケジュールを読み込んでいます。しばらくお待ちください。");

            axios.post("/api/get_schedules?api_token=" + this.api_token, {
                method: "POST",
                'scheduled_at': this.currentDate,
                'duration': 4,
            }).then(response => {

                this.callCloseAgentLoaderModal();

                if (response.data.success === false) {

                    alert(response.data.message);

                } else {

                    this.lessons = response.data.tutorLessonsData;
                    this.refreshContent();
                }

            }).catch(function (error) {
                alert("Error " + error);
            });
        },
        openMemberSelection(tutor, schedule) {
            if (this.$refs.AgentSchedulerComponent) {
                this.$refs.AgentSchedulerComponent.openSelectMemberModal(tutor, schedule);
            } else {
                console.error('Agent Scheduler component is not available.');
            }
        },
        cancelBooking(tutor, schedule) {
            this.$refs.AgentSchedulerComponent.openCancelBookingConfirmationModal(tutor, schedule);
        }

    },
};
</script>

<style>
.custom-wide-modal {
    max-width: 95%;
    width: 95%;
}

.custom-wide-modal .calendar {
    overflow: auto;
}

.vdp-datepicker__calendar {
    z-index: 999999999999;
}

.agent-reservation-modal-header {
    background: linear-gradient(135deg, #009de2, #19a5fc);
    color: #fff;
    border-radius: 0.3rem 0.3rem 0 0;
    padding: 0.85rem 1.25rem;
}

.agent-reservation-modal-header .modal-title {
    font-weight: 700;
    font-size: 1.1rem;
}

.agent-reservation-modal-header .close {
    color: #fff;
    text-shadow: none;
    opacity: 0.9;
}

.agent-reservation-modal-body {
    padding: 1rem 1.25rem 1.25rem;
    background: #f3f4f6;
}

.agent-reservation-modal-footer {
    padding: 0.75rem 1.25rem;
    background: #fff;
}

.agent-reservation-content {
    border: 1px solid #e5e7eb;
    overflow: hidden;
}
</style>

<style scoped>
#loadingModal {
    display: block;
    background-color: #0009;
}

.agent-reservation-toolbar {
    margin-bottom: 0;
}

.agent-reservation-date-label {
    letter-spacing: 0.02em;
}

.agent-reservation-legend {
    background: #fff;
    border-radius: 10px;
    border: 1px solid #e5e7eb;
}

.agent-reservation-legend-heading {
    font-size: 0.7rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #6b7280;
    margin-bottom: 0.5rem;
}

.agent-reservation-legend-status li {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    margin-bottom: 0.45rem;
    font-size: 0.8125rem;
    line-height: 1.35;
}

.agent-reservation-legend-status li:last-child {
    margin-bottom: 0;
}

.agent-reservation-legend-text {
    color: #374151;
    flex: 1;
}

.schedule-legend-chip {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 4.75rem;
    padding: 0.25rem 0.5rem;
    border-radius: 6px;
    font-size: 0.7rem;
    font-weight: 700;
    flex-shrink: 0;
    line-height: 1.25;
    text-align: center;
}

.schedule-legend-chip--bookable {
    background: #d1fae5;
    color: #047857;
}

.schedule-legend-chip--yours {
    background: #fee2e2;
    color: #b91c1c;
}

.schedule-legend-chip--other {
    background: #e5e7eb;
    color: #4b5563;
}

.agent-reservation-rules {
    font-size: 0.8125rem;
    line-height: 1.45;
    color: #4b5563;
}

.agent-reservation-rules li {
    margin-bottom: 0.35rem;
}

.agent-reservation-rules li:last-child {
    margin-bottom: 0;
}

.agent-reservation-date-banner {
    background: linear-gradient(135deg, #009de2, #19a5fc);
    padding: 0.55rem 1rem;
    font-size: 0.95rem;
    letter-spacing: 0.02em;
    border-radius: 8px 8px 0 0;
    margin: 0;
}

.agent-reservation-grid-wrap {
    height: 720px;
    overflow: auto;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-top: none;
    border-radius: 0 0 8px 8px;
}

.agent-reservation-table {
    border-collapse: separate;
    border-spacing: 0;
}

input.inputDate {
    overflow: hidden;
}

input.inputDate:before {
    content: attr(data-date);
}

input.inputDate::-webkit-datetime-edit,
input.inputDate::-webkit-inner-spin-button,
input.inputDate::-webkit-clear-button {
    display: none;
}

input.inputDate::-webkit-calendar-picker-indicator {
    position: absolute;
    top: 3px;
    right: 0;
    color: black;
    opacity: 1;
}


.modal-backdrop {
    background-color: #0009;
}

.table-schedules td {
    min-width: 52px;
    width: 52px;
    padding: 4px 2px;
    vertical-align: middle;
    border-color: #e5e7eb !important;
    background: #fff;
}

.agent-res-slot {
    background: #fafafa;
}

.table-schedules td.schedTime,
.table-schedules th.schedTime .agent-res-sched-corner-inner {
    background: #e0f2fe;
    text-align: center;
    vertical-align: middle;
}

.table-schedules td.schedTime {
    width: 44px;
    height: auto;
    min-height: 44px;
    position: -webkit-sticky;
    position: sticky;
    top: -1px;
    z-index: 5;
    padding: 0;
    border-color: #bae6fd !important;
}

.agent-res-time-cell {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 48px;
    padding: 6px 2px;
    border-bottom: 2px solid #7dd3fc;
    border-right: 1px solid #f0f9ff;
}

.agent-res-time-start {
    font-size: 0.7rem;
    font-weight: 700;
    color: #0c4a6e;
    line-height: 1.2;
}

.agent-res-time-end {
    font-size: 0.65rem;
    font-weight: 600;
    line-height: 1.2;
    margin-top: 2px;
}

.table-schedules th.schedTime .bordered,
.agent-res-sched-corner-inner {
    background: #e0f2fe;
    min-height: 48px;
    border-bottom: 2px solid #38bdf8;
    border-right: 2px solid #38bdf8;
}

.table-schedules td .bordered {
    width: 100%;
    height: 100%;
}

.table-schedules td.tutors,
.agent-res-tutor-cell {
    background: #fff;
    width: 88px;
    min-width: 88px;
    max-width: 88px;
    position: -webkit-sticky;
    position: sticky;
    left: -1px;
    z-index: 15;
    padding: 8px 6px !important;
    border-right: 2px solid #bae6fd !important;
    vertical-align: middle;
    box-shadow: 4px 0 8px -4px rgba(15, 23, 42, 0.12);
}

.agent-res-tutor-photo-wrap {
    display: flex;
    justify-content: center;
}

.agent-res-tutor-photo {
    width: 52px;
    height: 52px;
    object-fit: cover;
    border-radius: 50%;
    border: 2px solid #e5e7eb;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.agent-res-tutor-name {
    font-size: 0.75rem;
    font-weight: 700;
    color: #1f2937;
    margin-top: 6px;
    line-height: 1.2;
    word-break: break-word;
}

.table-schedules thead th {
    height: auto;
    position: -webkit-sticky;
    position: sticky;
    background-color: #fff;
    z-index: 12;
    width: 88px;
    top: -1px;
    padding: 0;
    vertical-align: top;
    border-color: #e5e7eb !important;
}

.agent-res-sched-corner {
    z-index: 20 !important;
    background: #e0f2fe !important;
}

.table-schedules tbody th,
.static {
    position: -webkit-sticky;
    position: sticky;
    left: -1px;
    background-color: #fff;
    border: 0;
    padding: 0;
    margin: 0;
    z-index: 100;
}

.table-schedules tbody th .hbordered {
    border-top: 0;
    border-left: 0;
    border-right: 3px solid #72add2;
    border-bottom: 1px solid #72add2;
    width: 100%;
    height: 100%;
    padding-left: 5px;
    padding-right: 5px;
}

.table-schedules td,
.table-schedules td div.gen-med {
    vertical-align: middle;
    min-height: 42px;
    font-size: 0.75rem;
    text-align: center;
}

.schedule-pill {
    display: inline-block;
    padding: 4px 5px;
    border-radius: 6px;
    font-size: 0.62rem;
    font-weight: 700;
    line-height: 1.25;
    max-width: 100%;
    box-sizing: border-box;
    word-break: keep-all;
}

.schedule-pill--other {
    background: #e5e7eb;
    color: #374151;
    border: 1px solid #d1d5db;
}

.schedule-pill--link {
    text-decoration: none;
    cursor: pointer;
}

.schedule-pill--link:hover {
    background: #d1d5db;
    color: #111827;
}

.schedule-action {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.68rem;
    font-weight: 700;
    text-align: center;
    text-decoration: none !important;
    line-height: 1.25;
    padding: 5px 4px;
    border-radius: 6px;
    max-width: 100%;
    box-sizing: border-box;
    word-break: keep-all;
}

.schedule-action--bookable {
    color: #047857 !important;
    background: #d1fae5;
    border: 1px solid #6ee7b7;
    min-height: 2rem;
    min-width: 3.25rem;
}

.schedule-action--bookable:hover {
    color: #065f46 !important;
    background: #a7f3d0;
}

.schedule-action--yours {
    color: #b91c1c !important;
    background: #fee2e2;
    border: 1px solid #fca5a5;
}

.schedule-action--yours:hover {
    color: #991b1b !important;
    background: #fecaca;
}

</style>